import * as $ from 'jquery';
import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { IValuesCollection } from './appTheme';
import { IAQLFilter } from '../tsx/filtering/Interfaces';
import { IAQLOptions } from '../../../pdc-platform/src/ts/Interfaces';

import * as DateTimeFunctions from './DateTimeFunctions';
import { nullHandlingBackend } from './nullHandling';

import { AppActions } from '../../../pdc-platform/src/ts/actions/AppActions';
import { NotificationType } from '../../../pdc-platform/src/ts/stores/NotificationsStore';
import * as Globalization from './Globalization';
import { themeVars } from '../../../pdc-platform/src/ts/themes/themeConstants';
import { config } from '../../../pdc-platform/src/ts/config';
import { MappingType } from './Interfaces';

export interface ISimpleIntervals {
    values?: any[];
    labels?: string[];
}

export interface ITimeIntervals {
    timePart?: string;
    normDate?;
    intervalLength?: number;
}

export interface INumberIntervals {
    intervalLength?: number;
    normValue?;
}

export interface ITimePeriods {
    timePeriod?;
    timePeriodStartMonth?: number;
    timePeriodTimeZoneAnother?: boolean;
    timePeriodTimeZone?: DateTimeFunctions.ITimeZone;
    timeZone?: string;
}

export interface IIntervalCommonParameters {
    timePart?: string;
    timeIntervals?: ITimeIntervals;
    timePeriodStartMonth?: number;
    numberIntervals?: INumberIntervals;
    timePeriods?: ITimePeriods;
    periodPoint?;
}

// It's right that it is in platform, but it is not for AQL. So it should be moved into better place.
export interface IIntervals extends ISimpleIntervals, IIntervalCommonParameters {
    useIntervalType?: any; //LL: 13.04.18
    useRegularIntervals?: boolean; //LL: 13.04.18: outdated, use useIntervalType
    modePredefinedOrOwn?: string;
    predefinedMapping?: { mappingName: string; mappingType: MappingType };
    step?: number;
}

export interface IIntervalParameters extends IIntervalCommonParameters {
    intervals?: ISimpleIntervals;
    firstWeekDay?: number;
}

export interface IAQLAttribute extends IIntervalParameters {
    attrib?: string[];
    syntaxTree?: any; // expression
    rettype?: string; // expression return type
}

export interface IAQLParameters {
    maxCacheAge?: number;
    minCacheTime?: number;
    sqlTimeOut?: number;
    maxNumberOfRecords?: number;
    timeZone?: string;
    nolock?: boolean;
    timePeriodStartMonth?: number;
    firstWeekDay?: number;
    queryRootEntity?: string;
    wsID?: number;
    widgetID?: number;
}

export interface ILoadDataResult {
    result: string[][];
    typeList: string[];
    age: number;
}

export interface IDataLoadRejectResult {
    canceled?: boolean;
}

export interface IAttributeReference extends IAQLAttribute {
    sort?: number;
    sort_desc?: boolean;
    sort_values?: boolean;

    agregate?: string;
    lookupType?: string;
}

export interface IDataParameters extends IAQLParameters {
    dataSourceID: number;

    attrib_refs: IAttributeReference[];
    group_attribs?: IAttributeReference[];

    filter?: IAQLFilter[];

    distinct?: boolean;

    limit?: number;
    offset?: number;
    fetch?: number;

    nullHandling?: nullHandlingBackend;
    specialMainGroupHandling?: boolean; //LL: 23.07.19 by Leo's request
}

export interface IRequestResult<T> {
    result: T;
}

export interface ICustomErrorMessage {
    code: number;
    message: string;
}

export interface INotificationOptions {
    runTimeWidgetID?: number;
    showInPopup?: boolean;
    suppressErrors?: boolean;
}

export const DEFAULT_MAX_CACHE_AGE = 86400; //In seconds.
export const DEFAULT_MIN_CACHE_AGE = 10; //In seconds.
export const DEFAULT_SQL_TIME_OUT_PERIOD = 120; //In seconds.

export const AQL = {
    TYPE_PERIOD: 'period',
    TYPE_OR: 'or',
    RELATION: 'relation',
    IN: 'in',
    NOT_IN: 'notin',
    LIKE: 'like',
    NOT_LIKE: 'notlike',
    IS_NULL: 'isNull',
    IS_NOT_NULL: 'isNotNull',
    EXISTS: 'exists',
    NOT_EXISTS: 'notExists',
    IS_SUBNODE_OF: 'is_subnode_of',
    IS_NOT_SUBNODE_OF: 'is_not_subnode_of',
    LOGICAL: 'logical'
};

// function requestWithOptions<T>(method: string, params, options, def?: JQuery.Deferred<IRequestResult<T>>) {
//     if (def == null) {
//         def = $.Deferred<IRequestResult<T>>();
//     }

//     try {
//         $.jsonRPC.withOptions(
//             options,

//             function () {
//                 const __this = this;

//                 __this.request(method, {
//                     params: params,

//                     success: function (resp, status) {
//                         def.resolve(resp, status);
//                     },

//                     error: function (resp, status) {
//                         def.reject(resp, status);
//                     }
//                 });
//             }
//         );
//     } catch (e) {
//         def.reject(e);
//     }

//     return def;
// }

// function request<T>(method: string, params, def?: JQuery.Deferred<IRequestResult<T>>) {
//     if (def == null) {
//         def = $.Deferred<IRequestResult<T>>();
//     }

//     try {
//         const requestPromise = $.jsonRPC.request(method, {
//             params: params,

//             success: function (resp, status) {
//                 def.resolve(resp, status);
//             },

//             error: function (resp, status) {
//                 def.reject(resp, status);
//             }
//         });
//     } catch (e) {
//         def.reject(e);
//     }

//     return def;
// }

let glob: IGlob;

export function aqlSetGlobObj(_glob: IGlob) {
    glob = _glob;
}

class AqlError extends Error {
    public status: number;
    constructor(message, status) {
        super(message);
        this.status = status;
    }
}

function request<T>(method: string, params, options?) {
    const def = $.Deferred<IRequestResult<T>>();

    const endPoint = options != null && options.endPoint != null ? options.endPoint : config.getAPIEndpoint() + '/api';

    try {
        const token = glob && glob.AuthStore.getUserToken();

        const httpHeaders = {
            'Content-Type': 'application/json'
        };

        if (token != null) {
            httpHeaders['Authorization'] = 'Bearer ' + token;
        }

        fetch(endPoint, {
            method: 'POST',
            headers: httpHeaders,
            body: JSON.stringify({
                method: method,
                params: params,
                id: 1
            })
        })
            .then(async (response) => {
                if (!response.ok) {
                    let errorInfo;
                    try {
                        // Try to get error details from response body
                        errorInfo = await response.json();
                    } catch (e) {
                        // Fallback if response isn't JSON
                        errorInfo = response.statusText;
                    }
                    const error = new AqlError(`HTTP ${response.status} ${JSON.stringify(errorInfo)}`, response.status);
                    throw error;
                } else {
                    return response.json();
                }
            })
            .then((result) => {
                def.resolve(result);
            })
            .catch((err) => {
                if (
                    err.message.includes('Failed to fetch') ||
                    err.message.includes('ERR_NAME_NOT_RESOLVED') ||
                    err instanceof TypeError
                ) {
                    def.reject({ error: 'Network failure: ' + (err.message || err.toString()) }, err.status);
                } else if (err instanceof SyntaxError) {
                    def.reject({ error: 'Malformed JSON: ' + (err.message || err.toString()) });
                } else if (err.name === 'AbortError') {
                    def.reject({ error: 'Timeout: ' + (err.message || err.toString()) }, err.status);
                } else {
                    def.reject({ error: err.message || err.toString() }, err.status);
                }
            });
    } catch (err) {
        if (
            err.message.includes('Failed to fetch') ||
            err.message.includes('ERR_NAME_NOT_RESOLVED') ||
            err instanceof TypeError
        ) {
            def.reject({ error: 'Network failure: ' + (err.message || err.toString()) }, err.status);
        } else if (err instanceof SyntaxError) {
            def.reject({ error: 'Malformed JSON: ' + (err.message || err.toString()) });
        } else if (err.name === 'AbortError') {
            def.reject({ error: 'Timeout: ' + (err.message || err.toString()) }, err.status);
        } else {
            def.reject({ error: err.message || err.toString() }, err.status);
        }
    }

    return def;
}

const SERVER_ERROR_FIRST = -32000;
const SERVER_ERROR_LAST = -32099;

const AUTH_ERROR_TOKEN_DOESNT_EXIST = SERVER_ERROR_FIRST - 22;
const AUTH_ERROR_UNATHORIZED = SERVER_ERROR_FIRST - 24;

const ERROR_SQL_CANCELED = -32004;

//EVG 26.11.21:
//I have removed showing Error Code for -32000 because there are too much feedback messages with the code.
//There is no need to show 'Error -32000' each time when user is notified that folder is not empty.
//It supposed to be validation error always, but backend often returns internal text of exception.
//It should be fixed later.
const ERROR_SQL_VALIDATION_ERROR = -32002;

interface IErrorMessage {
    data;
    message: string;
    type: NotificationType;
    //manualDestroy: boolean;
}

function processError(actions: AppActions, code: number, message: string, data, status): IErrorMessage {
    if (code === ERROR_SQL_CANCELED) {
        return;
    }

    let messageText: string;
    let messageType: NotificationType;
    //let manualDestroy = true;

    if (status === 401 || code === AUTH_ERROR_TOKEN_DOESNT_EXIST || code === AUTH_ERROR_UNATHORIZED) {
        messageText = 'Saved user token is invalid or expired, please log in again';
        messageType = 'warning';
        //manualDestroy = false;

        actions.unauthorized();
    } else if (code === ERROR_SQL_VALIDATION_ERROR) {
        messageType = 'warning';

        if (message.indexOf(`Error ${ERROR_SQL_VALIDATION_ERROR}: `) === 0) {
            message = message.slice(14, message.length);
        }
    } else {
        messageType = 'fail';
    }

    if (code != null && code < SERVER_ERROR_FIRST && code >= SERVER_ERROR_LAST && code !== ERROR_SQL_VALIDATION_ERROR) {
        messageText = `Error ${code}: ${message}`;
    }

    if (messageText == null) {
        messageText = message;
    }

    if (messageText != null) {
        return {
            message: messageText,
            data: data,
            type: messageType
            //manualDestroy: manualDestroy
        };
    }

    return;
}

function getObjProp(obj, propName) {
    if (typeof obj !== 'object' || obj == null) {
        return null;
    }

    return obj[propName];
}

function showErrorNotification(
    error: IErrorMessage,
    code: number,
    actions: AppActions,
    notificationOptions: INotificationOptions,
    customErrorMessages: ICustomErrorMessage[],
    manualDestroy?: boolean
) {
    if (notificationOptions != null && notificationOptions.suppressErrors === true) {
        return;
    }

    if (error != null && error.message != null) {
        let message = error.message;
        //let manualDestroy = error.manualDestroy;

        if (customErrorMessages != null) {
            if (code != null) {
                for (let i = 0; i < customErrorMessages.length; i++) {
                    if (customErrorMessages[i].code === code) {
                        message = customErrorMessages[i].message;
                        //manualDestroy = false;
                        break;
                    }
                }
            }
        }

        actions.showNotification(
            error.type,
            message,
            notificationOptions != null ? notificationOptions.runTimeWidgetID : null,
            {
                details: error.data,
                manualDestroy: manualDestroy != null && error.type !== 'warning' ? manualDestroy : error.data != null,
                showInPopup: notificationOptions != null ? notificationOptions.showInPopup : false
            }
        );
    }
}

function checkForErrors(
    response,
    status,
    actions: AppActions,
    notificationOptions: INotificationOptions,
    customErrorMessages?: ICustomErrorMessage[],
    manualDestroy?: boolean
) {
    if (response == null) {
        return;
    }
    const error = response.error;

    let code: number;
    let message: string;
    let data;

    if (error != null) {
        code = getObjProp(error, 'code');
        message = typeof error === 'string' ? error : getObjProp(error, 'message');
        data = getObjProp(error, 'data');
    } else {
        const responseResult = response.result;

        code = getObjProp(responseResult, 'code');
        message = getObjProp(responseResult, 'message');
        data = getObjProp(responseResult, 'data');
    }

    const errorMessageObj = processError(actions, code, message, data, status);

    showErrorNotification(errorMessageObj, code, actions, notificationOptions, customErrorMessages, manualDestroy);

    return errorMessageObj != null;
}

function isWaiting(deferred: JQuery.Deferred<any>) {
    return deferred != null && deferred.state() === 'pending';
}

export function apiCall<T>(
    actions: AppActions,
    method: string,
    parameters?,
    options?,
    deferred?: JQuery.Deferred<IRequestResult<T>>,
    notificationOptions?: INotificationOptions,
    customErrorMessages?: ICustomErrorMessage[],
    manualDestroy?: boolean
): JQuery.Promise<IRequestResult<T>> {
    const result = deferred || $.Deferred<IRequestResult<T>>();

    if (parameters == null) {
        parameters = {};
    }

    let def: JQuery.Deferred<IRequestResult<T>>;

    // if (options != null) {
    //     def = requestWithOptions<T>(method, parameters, options);
    // } else {
    //     def = request<T>(method, parameters);
    // }

    def = request<T>(method, parameters, options);

    def.done((response, status) => {
        if (isWaiting(result)) {
            if (checkForErrors(response, status, actions, notificationOptions, customErrorMessages, manualDestroy)) {
                result.reject(response);
            } else {
                return result.resolve(response);
            }
        }
    });

    def.fail((response, status) => {
        if (isWaiting(result)) {
            checkForErrors(response, status, actions, notificationOptions, customErrorMessages, manualDestroy);
            result.reject(response);
        }
    });

    return result.promise();
}

interface IQueryCollection {
    [id: string]: {
        deferred: JQuery.Deferred<IRequestResult<any>, IDataLoadRejectResult>;
        runTimeWidgetID: number;
        loadingPanelTimer: NodeJS.Timer;
    };
}

const ID_DELIMITER = '_';

function getRunTimeWidgetID(options: IAQLOptions) {
    if (options != null) {
        return options.getRunTimeWidgetID?.() ?? options.runTimeWidgetID;
    }

    return undefined;
}

export class AQLQueries {
    private glob: IGlob;
    private queryID = 0;
    private queryCollection: IQueryCollection = {};
    private isCanceling = false;

    constructor(glob: IGlob) {
        this.glob = glob;
    }

    private createQueryObj<T>(options: IAQLOptions) {
        const runTimeWidgetID = getRunTimeWidgetID(options);

        let workspace: number;
        let tab: number;
        let mainTab: number;
        let loadingPanelTimer: NodeJS.Timer;

        if (options != null) {
            workspace = options.workspace;
            tab = options.tab;
            mainTab = options.tab;
        }

        this.glob.AppActions.toolbarBottons_CancelOn();

        const useLoadingPanel = runTimeWidgetID != null;

        if (useLoadingPanel) {
            loadingPanelTimer = setTimeout(() => {
                this.glob.AppActions.showLoadingPanel(runTimeWidgetID);

                if (this.queryCollection[queryID] != null) {
                    delete this.queryCollection[queryID].loadingPanelTimer;
                }
            }, 1000);
        }

        const deferred = $.Deferred<IRequestResult<T>, IDataLoadRejectResult>();

        deferred.always(() => {
            if (useLoadingPanel) {
                this.hideLoadingPanel(queryID, runTimeWidgetID);
            }

            this.cleanQuery(queryID);
        });

        const queryID =
            (++this.queryID).toString() +
            ID_DELIMITER +
            (workspace != null ? workspace.toString() : '') +
            ID_DELIMITER +
            (tab != null ? tab.toString() : '') +
            ID_DELIMITER +
            (mainTab != null ? mainTab.toString() : '') +
            ID_DELIMITER +
            (runTimeWidgetID != null ? runTimeWidgetID.toString() : '');

        this.queryCollection[queryID] = {
            deferred: deferred,
            runTimeWidgetID: runTimeWidgetID,
            loadingPanelTimer: loadingPanelTimer
        };

        return {
            deferred,
            runTimeWidgetID
        };
    }

    private hideLoadingPanel(queryID: string, runTimeWidgetID: number) {
        const query = this.queryCollection[queryID];

        if (query != null) {
            if (query.loadingPanelTimer != null) {
                clearTimeout(query.loadingPanelTimer);
                delete query.loadingPanelTimer;
            } else {
                this.glob.AppActions.hideLoadingPanel(runTimeWidgetID);
            }
        }
    }

    private cleanQuery(queryID: string) {
        const query = this.queryCollection[queryID];

        if (query != null) {
            if (query.loadingPanelTimer != null) {
                clearTimeout(query.loadingPanelTimer);
            }

            delete this.queryCollection[queryID];
        }

        if (_.isEmpty(this.queryCollection)) {
            this.glob.AppActions.toolbarBottons_CancelOff();
        }
    }

    public getCanceling() {
        return this.isCanceling;
    }

    public cancelQueries(options?: IAQLOptions) {
        if (this.isCanceling) {
            return;
        }

        const queriesToReject: IQueryCollection = {};
        const runTimeWidgetID = getRunTimeWidgetID(options);

        let doCancel = false;

        for (let id in this.queryCollection) {
            const query = this.queryCollection[id];

            if (options != null) {
                const queryOptions = id.split(ID_DELIMITER);

                // if (options.workspace != null) {
                //     const workspace = queryOptions[1];

                //     if (workspace.length > 0) {
                //         if (options.workspace !== parseInt(workspace)) {
                //             continue;
                //         }

                //         if (options.tab != null) {
                //             const tab = queryOptions[2];

                //             if (tab.length > 0) {
                //                 if (options.tab !== parseInt(tab)) {
                //                     continue;
                //                 }

                //                 if (options.mainTab != null) {
                //                     const mainTab = queryOptions[3];

                //                     if (mainTab.length > 0) {
                //                         if (options.mainTab !== parseInt(mainTab)) {
                //                             continue;
                //                         }
                //                     }
                //                 }
                //             }
                //         }
                //     }
                // }
                //else
                if (options.runTimeWidgetID != null) {
                    const queryWidgetID = queryOptions[4];

                    if (runTimeWidgetID === parseInt(queryWidgetID)) {
                        this.hideLoadingPanel(id, runTimeWidgetID);
                    }
                    // else {
                    //     continue;
                    // }
                }
            }

            queriesToReject[id] = query;
            doCancel = true;
        }

        if (doCancel) {
            this.isCanceling = true;
            console.log('Canceling started');

            this.callMethod<any>('attrQuery_Cancel', {}, null, null, {
                runTimeWidgetID: runTimeWidgetID
            })
                .done(() => {
                    _.each(queriesToReject, (query, id) => {
                        query.deferred.reject({
                            canceled: true
                        });

                        this.cleanQuery(id);

                        if (query.runTimeWidgetID != null && options?.silent !== true) {
                            this.glob.AppActions.showNotification_Warning(
                                'Loading has been canceled. Click Refresh to resume.',
                                query.runTimeWidgetID
                            );
                        }
                    });
                })
                .always(() => {
                    console.log('Canceling finished');
                    this.isCanceling = false;
                });
        }
    }

    public getAQLParametersFromTheme(
        theme: IValuesCollection,
        cultureValues: Globalization.ICultureValues,
        refreshData: boolean
    ): IAQLParameters {
        let maxCacheAge: number;
        let minCacheTime: number;

        if (refreshData) {
            maxCacheAge = 0;
        } else if (theme != null) {
            maxCacheAge = theme['widget-max-cache-age'];
        }

        // See WI 103914. minCacheTime must be ignored.
        if (theme != null) {
            minCacheTime = theme['widget-min-cache-time'];
        }

        const result: IAQLParameters = {
            maxCacheAge: maxCacheAge != null ? maxCacheAge : DEFAULT_MAX_CACHE_AGE,
            minCacheTime: minCacheTime != null ? minCacheTime : DEFAULT_MIN_CACHE_AGE,
            maxNumberOfRecords: 0
        };

        if (theme != null) {
            const timeZone = DateTimeFunctions.getTimeZoneFromTheme(theme);
            const sqlTimeOut = theme[themeVars.widgetSQLTimeoutPeriod];
            const maxNumberOfRecords = theme[themeVars.widgetMaxNumberOfRecords];
            const timeZoneName = DateTimeFunctions.getTimeZoneName(timeZone);
            const useNolock = theme['widget-queries-nolock'];

            if (sqlTimeOut != null) {
                result.sqlTimeOut = sqlTimeOut;
            }

            if (maxNumberOfRecords != null) {
                result.maxNumberOfRecords = maxNumberOfRecords;
            }

            if (timeZoneName != null) {
                result.timeZone = timeZoneName;
            }

            if (useNolock === true) {
                result.nolock = true;
            }
        }

        if (cultureValues != null) {
            if (cultureValues.firstWeekDayNumber != Globalization.DEFAULT_FIRST_WEEK_DAY_NUMBER) {
                result.firstWeekDay = cultureValues.firstWeekDayNumber;
            }
            if (cultureValues.fiscalFirstMonth != Globalization.DEFAULT_FISCAL_FIRST_MONTH) {
                result.timePeriodStartMonth = cultureValues.fiscalFirstMonth;
            }
        }

        return result;
    }

    public isQueryRunning() {
        const query = _.find(this.queryCollection, (q) => {
            return q.deferred.state() === 'pending';
        });

        return query != null;
    }

    public loadData(
        parameters: IDataParameters,
        options: IAQLOptions
    ): JQuery.Promise<ILoadDataResult, IDataLoadRejectResult> {
        const result = $.Deferred<ILoadDataResult, IDataLoadRejectResult>();

        const { deferred, runTimeWidgetID } = this.createQueryObj<{
            result: string[][];
            TypeList: string[];
            age: number;
        }>(options);

        if (parameters.wsID == null) {
            parameters.wsID = options.workspace;
        }

        if (parameters.widgetID == null) {
            parameters.widgetID = options.staticWidgetID;
        }

        if (parameters.filter == null) {
            parameters.filter = [];
        }

        if (parameters.attrib_refs.length === 0 && options.allwowEmptyAttributeList !== true) {
            deferred.reject();
        } else {
            this.callMethod<any>('attrQuery_GetValueSet', parameters, null, deferred, {
                runTimeWidgetID: runTimeWidgetID
            });

            deferred
                .done((response) => {
                    result.resolve({
                        result: response.result.result,
                        typeList: response.result.TypeList,
                        age: response.result.age
                    });
                })
                .fail((response) => {
                    result.reject(response);
                });
        }

        return result.promise();
    }

    public callMethod<T>(
        method: string,
        parameters?,
        options?,
        deferred?: JQuery.Deferred<IRequestResult<T>>,
        notificationOptions?: INotificationOptions
    ) {
        return apiCall<T>(this.glob.AppActions, method, parameters, options, deferred, notificationOptions);
    }
}
